import * as React from 'react';

import { useEnterpriseLearningPathPageData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import EnterpriseLearningPathCurriculumModuleCountContext from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathCurriculumModuleCountContext';
import { useNaptime } from 'bundles/naptimejs';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import CourseScheduleV1 from 'bundles/naptimejs/resources/onDemandCourseSchedules.v1';

type PropsToComponent = {
  children: React.ReactNode;
};

const EnterpriseLearningPathCurriculumModuleCountProvider = ({ children }: PropsToComponent) => {
  const pageData = useEnterpriseLearningPathPageData();

  const courseIds = React.useMemo(() => {
    return pageData?.enterpriseBadge?.badgeActivities?.map((activity) => activity.id) ?? [];
  }, [pageData]);

  const naptimeResult = useNaptime(
    () => ({
      courseSchedules:
        courseIds.length > 0
          ? CourseScheduleV1.multiGet(courseIds, {
              fields: ['defaultSchedule'],
              required: false,
            })
          : undefined,
    }),
    [courseIds]
  );

  const courseSchedules = (naptimeResult.data as { courseSchedules?: CourseScheduleV1[] }).courseSchedules;
  const pending = naptimeResult.pending;

  // Create an object mapping course ID to number of periods (modules).
  const courseModuleCounts = React.useMemo(() => {
    const counts: Record<string, number> = {};

    if (courseSchedules) {
      courseSchedules.forEach((schedule) => {
        if (schedule?.id && schedule?.defaultSchedule?.periods) {
          counts[schedule.id] = schedule.defaultSchedule.periods.length;
        }
      });
    }

    return counts;
  }, [courseSchedules]);

  const isLoading = courseIds.length > 0 && pending;

  return (
    <EnterpriseLearningPathCurriculumModuleCountContext.Provider
      value={{
        courseModuleCounts,
        isLoading,
      }}
    >
      {children}
    </EnterpriseLearningPathCurriculumModuleCountContext.Provider>
  );
};

export default EnterpriseLearningPathCurriculumModuleCountProvider;
